import React, { MouseEventHandler } from "react";
import { STRINGS } from "../common/normalized-hardware-models";

type Props = {
  onClick: MouseEventHandler;
};

const CancelButton = ({ onClick }: Props) => {
  return (
    <button type="button" onClick={onClick}>
      {STRINGS.CANCEL_BUTTON_LABEL}
    </button>
  );
};

export default CancelButton;
